export type EntityHeaderImageVariant = 'image' | 'compact';
